<template>
  <div class="swiper other_0 m_con wow bounceInLeft">
    <el-carousel ref="carousel" trigger="click" arrow="always">
      <el-carousel-item v-for="item in slide" :key="item.imgUrl">
        <img :src="item.imgUrl" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { banner } from '@/api/index.js'
export default {
  data() {
    return {
      // 轮播图
      slide: []
    }
  },
  mounted() {
    this.$refs.carousel.handleMouseEnter = () => { };
    this.getbanner()
  },
  methods: {
    // 获取轮播
    async getbanner() {
      await banner({}).then((res) => {
        this.slide = res.data.bannerList
      })
    }
  }
}
</script>

<style lang="less" scoped>
.swiper {
  width: 100%;
  height: calc(100vh - 60px);
  background-color: #fff;
  // position: fixed;
  z-index: 1;
  @media screen and (max-width: 1400px) {
    height: 600px;
  }
  @media screen and (max-width: 760px) {
    height: 200px;
  }
  @media screen and (max-width: 475px) {
    width: 100%;
    height: 200px;
  }
  ::v-deep .el-carousel__indicators {
     display: none;
  }

  .el-carousel {
    height: 100%;
    /deep/.el-carousel__container {
      height: 100%;
    }
  }
  /deep/.el-carousel__container {
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
  }
  // .swiper-slide {
  //   width: 100%;
  //   font-size: 50px;
  //   text-align: center;
  // }
  // .swiper-pagination {
  //   .swiper-pagination-bullet {
  //     width: 30px;
  //     height: 2px;
  //     cursor: pointer;
  //     background-color: #fff;
  //     border-radius: 0;
  //   }
  // }
}
@keyframes likes {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

.el-carousel__item {
  animation-name: likes; // 动画名称
  animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放,alternate  normal。
  animation-timing-function: ease-in-out; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
  animation-delay: 1s; // 动画延迟时间
  animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
  animation-duration: 4s; // 动画完成时间
  overflow: hidden;
}
</style>
